import { isPlatformBrowser, NgTemplateOutlet } from "@angular/common";
import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";
import { LgIconComponent } from "@legal-and-general/canopy";
import { ImageComponent } from "../../globals/Image/Image.component";
import { LinkComponent } from "../../globals/Link/Link.component";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import { Store } from "@ngrx/store";
import { GlobalState } from "../../../store/global/global.reducer";
import { Observable } from "rxjs";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { AnalyticsService } from "../../../services/analytics/analytics.service";

@Component({
  selector: "dotcom-frontend-article-card-block",
  templateUrl: "./ArticleCardBlock.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrl: "./ArticleCardBlock.component.scss",
  standalone: true,
  imports: [LgIconComponent, ImageComponent, LinkComponent, NgTemplateOutlet]
})
export class ArticleCardBlockComponent implements DynamicComponent, OnInit {
  @Input() data: CmsData | undefined;
  pageTitle = "";
  isInColumnContentArea = false;
  isBrowser = isPlatformBrowser(this.platformId);
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);
  article: any;
  authorImages: any | undefined;
  pageStyle: string | undefined;
  category: { title: string; url: string } | undefined;
  date: string | undefined;

  constructor(
    private store: Store<{ global: GlobalState }>,
    private analyticsService: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }

  async ngOnInit() {
    if (this.data) {
      this.article = this.data["articleData"];

      if (this.data["pageStyle"]) {
        this.pageStyle = this.data["pageStyle"];
      }

      if (
        this.pageStyle === "blogarticlelisting" ||
        this.pageStyle === "authorlisting"
      ) {
        this.category = {
          title: this.article?.parentPageName,
          url: this.article?.parentLink?.url
        };
        if (this.article && this.article.articleDate) {
          this.date = new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
          }).format(new Date(this.article.articleDate));
        }
      }

      if (this.data["articleData"] && this.data["articleData"]["authorItems"]) {
        this.authorImages = [];
        this.data["articleData"]["authorItems"].forEach((item: any) => {
          this.authorImages.push({
            url: item["thumbnail"],
            expanded: {
              altText: item["fullName"]
            }
          });
        });
      }
    }
  }

  interactionClickEvent(clickUrl: any, clickName: any) {
    this.analyticsService.adobeInteractionEvent(
      "Article Card",
      clickUrl,
      clickName,
      "",
      "LinkClick",
      this.pageTitle,
      ""
    );
  }

  truncateTeaserText(text: string) {
    if (text) {
      const textArray = text.trim().split(/\s+/);

      if (textArray.length > 25) {
        const slicedArray = textArray.slice(0, 25);
        return slicedArray.join(" ") + "...";
      }
    }
    return text;
  }
}
